module.exports = __webpack_public_path__ + "img/1280x960.dda8c673.png";